// extracted by mini-css-extract-plugin
export default {"bar":"BookingSearchBox_bar__1c6oO","placeholder":"BookingSearchBox_placeholder__5LXS9"};